export default __webpack_public_path__ + "55f84eb107a5416f87a90039eb826ade.svg";